import { gql } from 'graphql-request';

export const ASSISTANT_CONVERSATION_FIELDS = gql`
  fragment AssistantConversationFields on AssistantConversationDto {
    conversationId
    organizationId
    projectId
    projectName
    title
    timezone
    status
    turns {
      role
      kind
      text
      at
      toolsUsed
      failed
    }
    pendingAction {
      type
      args
      humanSummary
      proposedAt
      expectedState
    }
    errorCode
    model
    turnCount
    inputTokens
    outputTokens
    cacheReadInputTokens
    createdAt
    updatedAt
  }
`;

export const assistantAvailable = gql`
  query assistantAvailable {
    assistantAvailable
  }
`;

export const assistantConversation = gql`
  query assistantConversation($conversationId: String!) {
    assistantConversation(conversationId: $conversationId) {
      ...AssistantConversationFields
    }
  }
  ${ASSISTANT_CONVERSATION_FIELDS}
`;

export const myAssistantConversations = gql`
  query myAssistantConversations {
    myAssistantConversations {
      ...AssistantConversationFields
    }
  }
  ${ASSISTANT_CONVERSATION_FIELDS}
`;

export const myLatestAssistantConversationForProject = gql`
  query myLatestAssistantConversationForProject($projectId: String!) {
    myLatestAssistantConversationForProject(projectId: $projectId) {
      ...AssistantConversationFields
    }
  }
  ${ASSISTANT_CONVERSATION_FIELDS}
`;

export const sendAssistantMessage = gql`
  mutation sendAssistantMessage($input: SendAssistantMessageInput!) {
    sendAssistantMessage(input: $input) {
      ...AssistantConversationFields
    }
  }
  ${ASSISTANT_CONVERSATION_FIELDS}
`;

export const confirmAssistantAction = gql`
  mutation confirmAssistantAction($conversationId: String!) {
    confirmAssistantAction(conversationId: $conversationId) {
      ...AssistantConversationFields
    }
  }
  ${ASSISTANT_CONVERSATION_FIELDS}
`;

export const dismissAssistantAction = gql`
  mutation dismissAssistantAction($conversationId: String!) {
    dismissAssistantAction(conversationId: $conversationId) {
      ...AssistantConversationFields
    }
  }
  ${ASSISTANT_CONVERSATION_FIELDS}
`;

export const deleteAssistantConversation = gql`
  mutation deleteAssistantConversation($conversationId: String!) {
    deleteAssistantConversation(conversationId: $conversationId)
  }
`;

const AssistantGraphQL = {
  queries: {
    assistantAvailable,
    assistantConversation,
    myAssistantConversations,
    myLatestAssistantConversationForProject,
  },
  mutations: {
    sendAssistantMessage,
    confirmAssistantAction,
    dismissAssistantAction,
    deleteAssistantConversation,
  },
};

export default AssistantGraphQL;
